import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { FixedTitle } from '@tphglobal/common/utils';
import { Grid } from '@mui/material';

const Disclaimer: React.FC = () => {
  return (
    <Grid container justifyContent='center' pb={3} px={3}>
      <FixedTitle varient='Fixed14Medium' component={'div'}>
        <List
          sx={{
            listStyleType: 'disc',
            textAlign: 'justify',
            pl: 3,
            '& .MuiListItem-root': {
              display: 'list-item',
              textAlign: 'justify',
            },
            paddingTop: '0',
          }}
        >
          <ListItem>
            By pressing 'submit', I understand and agree that:
          </ListItem>
          <ListItem>
            I agree to use of electronic records and signatures;
          </ListItem>
          <ListItem>
            I must provide you with timely and complete information to enable
            you to perform the Services and I am solely responsible for the
            accuracy and completeness of any information I provide to you;
          </ListItem>
          <ListItem>
            You will rely on the information I provide, and you are not required
            to independently verify or correct any such information; and
          </ListItem>
          <ListItem>
            I accept sole responsibility for any liability arising from my
            failure to provide accurate and complete information, and to the
            extent permitted by law, I waive and release you from any liability
            resulting from my failure to do so.
          </ListItem>
        </List>
      </FixedTitle>
    </Grid>
  );
};

export default Disclaimer;
